export default "__VITE_ASSET__D$zQFL4D__"